import { render, staticRenderFns } from "./ComplianceTypeField.vue?vue&type=template&id=267f0fa6&scoped=true"
import script from "./ComplianceTypeField.vue?vue&type=script&lang=js"
export * from "./ComplianceTypeField.vue?vue&type=script&lang=js"
import style0 from "./ComplianceTypeField.vue?vue&type=style&index=0&id=267f0fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f0fa6",
  null
  
)

export default component.exports